import React from "react";
import { Container, Form } from "react-bootstrap";
import { database } from "../firebase/firebase";

export default class OrderForm extends React.Component {
  constructor(props) {
    super(props);
    this.onValidate = this.onValidate.bind(this);
  }

  onChange(field) {
    return (event) => this.props.onChange({ [field]: event.target.value });
  }

  onValidate(event) {
    event.preventDefault();
    const clientInfo = this.props.value;
    database.ref("orderInfo").push(clientInfo);
    // console.log('validated !', this.props.value)
  }

  render() {
    return (
      <Container className="order-form">
        <h4>Thông tin giao hàng</h4>
        <Form onSubmit={this.onValidate}>
          <Form.Group controlId="input-name">
            <Form.Label>
              <strong>Tên của quý khách</strong>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Họ và tên"
              value={this.props.value.name}
              onChange={this.onChange("name")}
            />
          </Form.Group>
          <Form.Group controlId="input-phone">
            <Form.Label>
              <strong>Số Điện Thoại</strong>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Số Điện Thoại"
              value={this.props.value.phone}
              onChange={this.onChange("phone")}
            />
          </Form.Group>
          <Form.Group controlId="input-email">
            <Form.Label>
              <strong>Email</strong>
            </Form.Label>
            <Form.Control
              type="email"
              placeholder="Email"
              value={this.props.value.email}
              onChange={this.onChange("email")}
            />
          </Form.Group>
          <Form.Group controlId="input-address">
            <Form.Label>
              <strong>Địa Chỉ Giao Hàng</strong>
            </Form.Label>
            <Form.Control
              as="textarea"
              rows="3"
              value={this.props.value.address}
              onChange={this.onChange("address")}
            />
          </Form.Group>
        </Form>
      </Container>
    );
  }
}
